module.exports = __webpack_public_path__ + "img/hashbrown-potatoes.dfd69776.jpg";